// extracted by mini-css-extract-plugin
export var textInput = "_c1-0";